import React from "react";
import { useTranslation } from "react-i18next";
import { trackConversion } from "../../lib/analytics";
import {
  webinar,
  isWebinarVisible,
  getWebinarTitle,
  getWebinarTagline,
  getWebinarDateLabel,
} from "../../lib/webinar";

/**
 * Sección destacada del webinar para la Home (mismo lenguaje visual que
 * PlaybooksBanner). El CTA lleva directo al evento de Meetup.
 */
const WebinarSection = () => {
  const { t, i18n } = useTranslation();

  if (!isWebinarVisible()) return null;

  const lang = i18n && i18n.language ? i18n.language : "es";
  const dateLabel = getWebinarDateLabel(lang);

  return (
    <section className="webinar-section">
      <div className="container">
        <div className="webinar-section__inner">
          <div className="webinar-section__content">
            <span className="webinar-section__kicker">
              <span className="webinar-section__dot" aria-hidden="true" />
              {t("webinar_live_label")}
            </span>
            <h2 className="webinar-section__title">{getWebinarTitle(lang)}</h2>
            <p className="webinar-section__tagline">{getWebinarTagline(lang)}</p>
            {dateLabel ? (
              <p className="webinar-section__meta">
                <span className="webinar-section__meta-icon" aria-hidden="true">
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#a49dff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="4" width="18" height="18" rx="3" />
                    <path d="M3 9h18M8 2v4M16 2v4" />
                  </svg>
                </span>
                {dateLabel}
                <span className="webinar-section__meta-sep">·</span>
                {t("webinar_platform")}
              </p>
            ) : null}
          </div>
          <div className="webinar-section__actions">
            <a
              className="z-btn webinar-section__cta"
              href={webinar.meetupUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackConversion("Webinar Section CTA")}
            >
              {t("webinar_cta")}
            </a>
            <span className="webinar-section__note">{t("webinar_note")}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebinarSection;
